module.exports = __webpack_public_path__ + "static/img/隋准B.23a81a51.png";